import { QueryClient } from '@tanstack/react-query'

// Module singleton so non-React code (auth) can drop cached data on identity change.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
